import { StoreEnhancer } from 'redux';
import { AnalyticsData } from './hooks/useAnalytics';

export interface Credentials {
  cloudName: string;
  apiKey: string;
}

export interface AuthState extends Credentials {
  previousCredentials?: Credentials;
}
export interface MediaType {
  type: string;
  url: string;
}
export type MediaState = Array<MediaType>;

export interface FilterByAssetOption {
  value?: string;
  label: string;
}

type ResponseType = Record<string, unknown>;

export type ConsoleResponseState = Array<ResponseType>;

export enum FilterType {
  Folder = 'folder',
  Search = 'search',
}

export interface GeneratedExpressionInterface {
  isSearchFilterByAsset?: boolean;
  isSearchFilterByCustomExpression?: boolean;
  filterByAsset?: FilterByAssetOption;
  filterByExpression?: string;
}

export interface OptionsState {
  insertCaption?: string;
  inlineContainer?: string;
  inlineMode?: boolean;
  removeHeader?: boolean;
  maxFiles?: string;
  filterSelection?: FilterType;
  isSearchFilterByAsset?: boolean;
  isSearchFilterByCustomExpression?: boolean;
  filterByAsset?: FilterByAssetOption;
  filterByExpression?: string;
  folderName?: string;
  defaultTransformations?: Array<Array<TransformationDefinition>>;
  transformations?: Array<TransformationInterface>;
  areCustomTransformationsEnabled?: boolean;
  customTransformations?: string;
  folder?: {
    path: string;
  };
  search?: {
    expression: string;
  };
}

export interface SearchOptions {
  filterByExpression?: string;
  filterByAsset?: FilterByAssetOption;
  isSearchFilterByAsset?: boolean;
  isSearchFilterByCustomExpression?: boolean;
}

export interface RootState {
  media: MediaState;
  options: OptionsState;
  auth: AuthState;
  consoleResponse: ConsoleResponseState;
}

export interface CloudinaryAssetDerived {
  // eslint-disable-next-line camelcase
  secure_url: string;
  // eslint-disable-next-line camelcase
  raw_transformation?: string;
  url?: string;
}
export interface CloudinaryData {
  assets: Array<{
    derived?: Array<CloudinaryAssetDerived>;
    // eslint-disable-next-line camelcase
    secure_url: string;
    // eslint-disable-next-line camelcase
    resource_type: string;
  }>;
}
export interface RawTransformation {
  // eslint-disable-next-line camelcase
  raw_transformation?: string;
}

export interface TransformationDefinition extends RawTransformation {
  effect?: string;
  angle?: number;
  radius?: number;
  border?: string;
  color?: string;
  overlay?: Record<string, string | number>;
}
export interface TransformationInterface {
  label: string;
  key: string;
  image: string;
  definition: TransformationDefinition;
  isSelected?: boolean;
}

interface DataLayerData extends AnalyticsData {
  event: string;
  eventCategory: string;
}

// Cannot be declared as global due to overlapping of global types between apps in tests
export interface WindowExtended extends Window {
  __REDUX_DEVTOOLS_EXTENSION__: () => StoreEnhancer;
  cloudinary: {
    openMediaLibrary(
      configuraion: unknown,
      callback: unknown
    ): {
      show(): void;
    };
  };
  dataLayer: DataLayerData[],
}
